// Localized SEO metadata for public pages. Keyed by page, then language.
// Keep titles ~60 chars and descriptions ~150-160 chars, keyword-rich for Almaty/Kazakhstan.

export const SEO_META = {
  home: {
    ru: {
      title: 'Ainanan — свежая выпечка с доставкой в Алматы | Круассаны, сэндвичи',
      description:
        'Свежие круассаны, сэндвичи из круассана, панини, донатсы, слойки и десерты с доставкой по Алматы. Выпечка на заказ для дома, офиса и мероприятий. B2B оптом.',
    },
    en: {
      title: 'Ainanan — Fresh Bakery Delivery in Almaty | Croissants & Sandwiches',
      description:
        'Fresh croissants, croissant sandwiches, paninis, donuts, pastries and desserts delivered across Almaty. Made-to-order bakery for home, office and events. B2B wholesale.',
    },
    kz: {
      title: 'Ainanan — Алматыда жеткізумен балғын нан-тоқаш | Круассандар',
      description:
        'Алматы бойынша жеткізумен балғын круассандар, сэндвичтер, панини, пончиктер, тоқаштар мен десерттер. Үй, кеңсе және іс-шараларға тапсырыспен. B2B көтерме.',
    },
  },
  about: {
    ru: {
      title: 'О компании Ainanan — пекарня и поставщик выпечки в Алматы',
      description:
        'Ainanan — пекарня полного цикла в Алматы: свежая выпечка для дома и бизнеса, оптовые поставки для кафе, ресторанов и кофеен. Узнайте больше о нас.',
    },
    en: {
      title: 'About Ainanan — Bakery and Pastry Supplier in Almaty',
      description:
        'Ainanan is a full-cycle bakery in Almaty: fresh pastries for home and business, wholesale supply for cafes, restaurants and coffee shops. Learn more about us.',
    },
    kz: {
      title: 'Ainanan туралы — Алматыдағы наубайхана және нан жеткізуші',
      description:
        'Ainanan — Алматыдағы толық циклді наубайхана: үй мен бизнеске балғын нан-тоқаш, кафе, мейрамхана және кофеханаларға көтерме жеткізу. Біз туралы көбірек біліңіз.',
    },
  },
  contacts: {
    ru: {
      title: 'Контакты Ainanan — заказ выпечки и доставка в Алматы',
      description:
        'Свяжитесь с Ainanan: телефон, WhatsApp, адрес в Алматы (ул. Баранского 15/1), часы работы. Заказ выпечки с доставкой и оптовые B2B-поставки.',
    },
    en: {
      title: 'Contact Ainanan — Bakery Orders and Delivery in Almaty',
      description:
        'Contact Ainanan: phone, WhatsApp, address in Almaty (Baranskogo St 15/1), working hours. Bakery orders with delivery and B2B wholesale supply.',
    },
    kz: {
      title: 'Ainanan байланыс — Алматыда нан тапсырысы және жеткізу',
      description:
        'Ainanan-мен байланысыңыз: телефон, WhatsApp, Алматыдағы мекенжай (Баранский к-сі 15/1), жұмыс уақыты. Жеткізумен нан тапсырысы және B2B көтерме.',
    },
  },
  b2bMenu: {
    ru: {
      title: 'B2B меню Ainanan — оптовые поставки выпечки для кафе и ресторанов',
      description:
        'Оптовый прайс и меню Ainanan для бизнеса: круассаны, сэндвичи, выпечка и полуфабрикаты для кафе, ресторанов, кофеен и отелей в Алматы. Заявка за минуту.',
    },
    en: {
      title: 'Ainanan B2B Menu — Wholesale Bakery Supply for Cafes & Restaurants',
      description:
        'Ainanan wholesale menu for business: croissants, sandwiches, pastries and semi-finished goods for cafes, restaurants, coffee shops and hotels in Almaty.',
    },
    kz: {
      title: 'Ainanan B2B мәзірі — кафе мен мейрамханаларға көтерме нан жеткізу',
      description:
        'Бизнеске арналған Ainanan көтерме мәзірі: Алматыдағы кафе, мейрамхана, кофехана және қонақүйлерге круассандар, сэндвичтер, нан-тоқаш және жартылай фабрикаттар.',
    },
  },
  login: {
    ru: {
      title: 'Вход в личный кабинет — Ainanan',
      description: 'Войдите в личный кабинет Ainanan, чтобы оформлять заказы выпечки с доставкой по Алматы, отслеживать статус и просматривать историю заказов.',
    },
    en: {
      title: 'Sign In to Your Account — Ainanan',
      description: 'Sign in to your Ainanan account to order fresh bakery with delivery across Almaty, track order status and view your order history.',
    },
    kz: {
      title: 'Жеке кабинетке кіру — Ainanan',
      description: 'Алматы бойынша жеткізумен нан-тоқаш тапсырыс беру, мәртебесін қадағалау және тапсырыс тарихын көру үшін Ainanan жеке кабинетіне кіріңіз.',
    },
  },
  register: {
    ru: {
      title: 'Регистрация — Ainanan | Создать аккаунт B2C или B2B',
      description: 'Зарегистрируйтесь в Ainanan: личный аккаунт для заказов выпечки с доставкой по Алматы или B2B-аккаунт для оптовых поставок кафе и ресторанам.',
    },
    en: {
      title: 'Sign Up — Ainanan | Create a B2C or B2B Account',
      description: 'Create an Ainanan account: a personal account to order bakery delivery in Almaty, or a B2B account for wholesale supply to cafes and restaurants.',
    },
    kz: {
      title: 'Тіркелу — Ainanan | B2C немесе B2B аккаунт ашу',
      description: 'Ainanan-да тіркеліңіз: Алматыда нан-тоқаш жеткізуге арналған жеке аккаунт немесе кафе мен мейрамханаларға көтерме жеткізуге B2B аккаунт.',
    },
  },
  forgotPassword: {
    ru: {
      title: 'Восстановление пароля — Ainanan',
      description: 'Забыли пароль от аккаунта Ainanan? Введите email, и мы отправим ссылку для восстановления доступа к личному кабинету.',
    },
    en: {
      title: 'Reset Password — Ainanan',
      description: 'Forgot your Ainanan password? Enter your email and we will send you a link to restore access to your account.',
    },
    kz: {
      title: 'Құпиясөзді қалпына келтіру — Ainanan',
      description: 'Ainanan аккаунтының құпиясөзін ұмыттыңыз ба? Email енгізіңіз, біз жеке кабинетке кіруді қалпына келтіру сілтемесін жібереміз.',
    },
  },
};

export const pickMeta = (page, lang) => {
  const byLang = SEO_META[page] || {};
  return byLang[lang] || byLang.ru;
};
